import { Flex, FlexProps } from 'antd'

export interface KBFlexProps extends FlexProps {}

export const KBFlex = forwardRef<HTMLDivElement, KBFlexProps>((props, ref) => {
  return <Flex ref={ref} {...props}></Flex>
})
